import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createDirectMessageOutbound } from '../../api/outbound/directMessagesOutbounds';
import { MessageInput } from '../messageInput';
export const DirectMessageInput = ({ conversation }) => {
    const { id: conversationPlayerId, name: conversationUsername } = conversation.playerIdName;
    const privateMessageInputHandler = useCallback((socketSend, message) => {
        socketSend(createDirectMessageOutbound(conversationPlayerId, message));
    }, [conversationPlayerId]);
    return (_jsx(MessageInput, { type: 'direct-message', messageInputHandler: privateMessageInputHandler, label: `Message ${conversationUsername}`, sendButtonTitle: `Message ${conversationUsername}` }));
};
